/* eslint-disable */
import React from 'react'
import {Link} from 'react-router-dom'
import http from '../../Component/Interceptor/Interseptor'
import {message} from 'antd'
import Page from '../../Component/Pagination/Pagination'
import HeaderTable from '../BaseComponent/HeaderTable'
import jMoment from 'moment-jalaali'
import $ from 'jquery'
import cookie from 'react-cookies'
import FromToPicker from '../BaseComponent/FromToPicker'
import HeaderTablePrint from '../BaseComponent/HeaderTablePrint'
import ExcelExport from '@progress/kendo-react-excel-export/dist/npm/ExcelExport'
import USER_REPORT from '../BaseComponent/USERREPORT'

class PersinaUsers extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      persina: [],
      fromDate: '',
      toDate: '',
      printInfo: []
    }
  }

  fetchPersinaUsers(userCode) {
    sessionStorage.setItem('params', `userCode=${userCode}`)

    http
      .get(
        USER_REPORT.USER_REPORT_ASPUSER + '?export=false' + '&pageSize=10' + '&pageNumber=1' + `&userCode=${userCode}`
      )
      .then((response) => {
        if (response.data.error == null) {
          $('.showBaseTable,.print').fadeIn()
          this.setState({
            persina: response.data.object.result,
            total: response.data.object.countAll,
            toPrintDate: '-',
            fromPrintDate: '-'
          })
        } else {
          $('.showBaseTable,.print').fadeOut()
          message.error('خطای ' + response.data.errorCode + ' : ' + response.data.description)
          this.setState({
            persina: []
          })
        }
      })
      .catch((error) => {
        alert(JSON.stringify(error))
      })
  }

  componentDidMount() {
    if (this.props.match.params.userCode != undefined) {
      this.fetchPersinaUsers(this.props.match.params.userCode || '')
    }

    $(function() {
      $('.filterBtn').on('click', function() {
        $('.filterComponent').slideToggle()
      })

      $('.cancelFilter').click(function() {
        $('.filterComponent').slideUp()
      })
    })
    sessionStorage.setItem('pageNumber', '1')
    sessionStorage.setItem('dropDownVal', '10')
  }

  componentWillReceiveProps(nextProps, nextContext) {
    if (this.props.match.params.userCode !== nextProps.match.params.userCode) {
      console.log('update')
      this.fetchPersinaUsers(nextProps.match.params.userCode || '')
      return false
    }
  }

  changeDropDown(data) {
    this.setState({
      persina: data,
      DriversCount: sessionStorage.getItem('countAll')
    })
  }

  onResultFetched(data) {
    this.setState({
      persina: data
    })
  }

  handleChangeFromDate = (fromDate) => {
    this.setState({
      fromDate
    })
  }

  handleChangeToDate = (toDate) => {
    this.setState({
      toDate
    })
  }

  filter() {
    sessionStorage.setItem('pageNumber', '1')
    sessionStorage.setItem('dropDownVal', '10')
    var firstname = document.getElementById('firstname').value
    var lastname = document.getElementById('lastname').value
    var username = document.getElementById('username').value
    var phone = document.getElementById('phone').value
    var legal = document.getElementById('legal').value
    var userCode = document.getElementById('userCode').value
    var organization = document.getElementById('organization').value
    var phoneConfirmed = document.getElementById('phoneConfirmed').value
    var emailConfirmed = document.getElementById('emailConfirmed').value
    var email = document.getElementById('email').value
    let registrationTimeMin = this.state.fromDate
    let registrationTimeMax = this.state.toDate
    if (
      emailConfirmed === '' &&
      phoneConfirmed === '' &&
      firstname == '' &&
      lastname == '' &&
      username == '' &&
      phone == '' &&
      legal == '' &&
      userCode == '' &&
      registrationTimeMin == '' &&
      registrationTimeMax == '' &&
      organization == '' &&
      email == ''
    ) {
      message.error('حداقل یک فیلتر وارد شود')
    } else if ((registrationTimeMin != '' || registrationTimeMin == null) && isNaN(registrationTimeMin)) {
      message.error('فرمت تاریخ ابتدا صحیح نیست')
    } else if ((registrationTimeMax != '' || registrationTimeMax == null) && isNaN(registrationTimeMax)) {
      message.error('فرمت تاریخ انتها صحیح نیست')
    } else {
      this.setState({
        toPrintDate: this.state.toDate == '' ? '-' : jMoment(this.state.toDate).format('jYY/jM/jD'),
        fromPrintDate: this.state.fromDate == '' ? '-' : jMoment(this.state.fromDate).format('jYY/jM/jD')
      })

      sessionStorage.setItem(
        'params',
        `phoneConfirmed=${phoneConfirmed}&emailConfirmed=${emailConfirmed}&email=${email}&organization=${organization}&userCode=${userCode}&phone=${phone}&username=${username}&firstName=${firstname}&lastName=${lastname}&registrationTimeMin=${
          registrationTimeMin == '' ? '' : registrationTimeMin
        }&registrationTimeMax=${registrationTimeMax == '' ? '' : registrationTimeMax}&legal=${legal}`
      )
      http
        .get(
          `${USER_REPORT.USER_REPORT_ASPUSER}?export=false&pageNumber=1&pageSize=10&${sessionStorage.getItem(
            'params'
          )}`,
          {}
        )
        .then((response) => {
          if (response.data.error == null) {
            $('.showBaseTable,.print').fadeIn()
            this.setState({
              persina: response.data.object.result,
              total: response.data.object.countAll
            })
          } else {
            $('.showBaseTable,.print').fadeOut()
            message.error('خطای ' + response.data.errorCode + ' : ' + response.data.description)
            this.setState({
              persina: []
            })
          }
        })
    }
  }

  exportExcel = () => {
    http
      .get(
        `${USER_REPORT.USER_REPORT_ASPUSER}?export=true&pageSize=10&pageNumber=1&${sessionStorage.getItem('params')}`,
        {}
      )
      .then((response) => {
        // alert(JSON.stringify(response.data))
        if (response.data.error == null) {
          console.log(response.data)
          // $('.showBaseTable,.print').fadeIn();

          sessionStorage.setItem('countAll', response.data.object.countAll)
          this.setState({
            excelReport: response.data.object.result
          })
          let {excelReport} = this.state
          for (let i = 0; i < excelReport.length; i++) {
            excelReport[i]['registrationTime'] = jMoment(excelReport[i]['registrationTime']).format('jYY/jMM/jDD')

            if (excelReport[i]['legal']) {
              excelReport[i]['legal'] = 'حقوقی'
            } else {
              excelReport[i]['legal'] = 'حقیقی'
            }

            if (excelReport[i]['phoneConfirmed']) {
              excelReport[i]['phoneConfirmed'] = 'تایید شده'
            } else {
              excelReport[i]['phoneConfirmed'] = 'تایید نشده'
            }

            if (excelReport[i]['emailConfirmed']) {
              excelReport[i]['emailConfirmed'] = 'تایید شده'
            } else {
              excelReport[i]['emailConfirmed'] = 'تایید نشده'
            }
          }

          this._export.save(this.state.excelReport)
        } else {
          this.setState({
            excelReport: []
          })
        }
      })
      .catch((error) => {
        // alert(JSON.stringify(error))
      })

    // this._export.save(excelData)
  }

  getPrintInfo = () => {
    http
      .get(
        `${USER_REPORT.USER_REPORT_ASPUSER}?export=true&pageSize=10&pageNumber=1&${sessionStorage.getItem('params')}`,
        {}
      )
      .then((response) => {
        if (response.data.error == null) {
          sessionStorage.setItem('countAll', response.data.object.countAll)
          this.setState({
            printInfo: response.data.object.result
          })
        } else {
          this.setState({
            printInfo: []
          })
        }
      })
      .catch((error) => {
        // alert(JSON.stringify(error))
      })
  }

  exportPrint = () => {
    var css = '@page { size:A4 portrait;}',
      head = document.head || document.getElementsByTagName('head')[0],
      style = document.createElement('style')

    style.type = 'text/css'
    style.media = 'print'

    if (style.styleSheet) {
      style.styleSheet.cssText = css
    } else {
      style.appendChild(document.createTextNode(css))
    }

    head.appendChild(style)
    this.getPrintInfo()
    setTimeout(() => {
      window.print()
    }, 2000)
  }

  render() {
    let pageNumber = sessionStorage.getItem('pageNumber')
    let dropDownVal = sessionStorage.getItem('dropDownVal')
    let reporterName = cookie.load('name')
    let columnPrint = [
      'ردیف',
      'نام ',
      'نوع کاربر',
      'نام کاربری',
      'تلفن',
      'تایید تلفن',
      'کد کاربر',
      'تاریخ ثبت',
      'ایمیل',
      'تایید ایمیل',
      'نام سازمان'
    ]
    return (
      <div className="rtl printA4Page">
        <div className="excelSection">
          <ExcelExport
            dir="rtl"
            ref={(exporter) => {
              this._export = exporter
            }}
            fileName="گزارش کاربران پرسینا.xls"
          >
            <grid style={{height: '420px'}} data={this.state.excelReport}>
              <gridColumn
                key={'firstName'}
                field={'firstName'}
                title={'نام'}
                width="100px"
                groupFooterCellOptions={{wrap: true, textAlign: 'center'}}
              />
              <gridColumn
                key={'lastName'}
                field={'lastName'}
                title={'نام خانوادگی'}
                width="100px"
                groupFooterCellOptions={{wrap: true, textAlign: 'center'}}
              />
              <gridColumn
                key={'username'}
                field={'username'}
                title={'نام کاربری'}
                width="100px"
                groupFooterCellOptions={{wrap: true, textAlign: 'center'}}
              />

              <gridColumn
                key={'legal'}
                field={'legal'}
                title={'نوع کاربر'}
                width="100px"
                groupFooterCellOptions={{wrap: true, textAlign: 'center'}}
              />

              <gridColumn
                key={'userCode'}
                field={'userCode'}
                title={'کد کاربر'}
                width="100px"
                groupFooterCellOptions={{wrap: true, textAlign: 'center'}}
              />

              <gridColumn
                key={'phone'}
                field={'phone'}
                title={' تلفن'}
                width="250px"
                groupFooterCellOptions={{wrap: true, textAlign: 'center'}}
              />

              <gridColumn
                key={'phoneConfirmed'}
                field={'phoneConfirmed'}
                title={'تایید تلفن'}
                width="250px"
                groupFooterCellOptions={{wrap: true, textAlign: 'center'}}
              />

              <gridColumn
                key={'email'}
                field={'email'}
                title={'ایمیل'}
                width="250px"
                groupFooterCellOptions={{wrap: true, textAlign: 'center'}}
              />

              <gridColumn
                key={'emailConfirmed'}
                field={'emailConfirmed'}
                title={'تایید ایمیل'}
                width="250px"
                groupFooterCellOptions={{wrap: true, textAlign: 'center'}}
              />

              <gridColumn
                key={'organization'}
                field={'organization'}
                title={'نام سازمانی'}
                width="100px"
                groupFooterCellOptions={{wrap: true, textAlign: 'center'}}
              />

              <gridColumn
                key={'registrationTime'}
                field={'registrationTime'}
                title={'تاریخ ثبت'}
                width="100px"
                groupFooterCellOptions={{wrap: true, textAlign: 'center'}}
              />
            </grid>
          </ExcelExport>
        </div>

        <div className="printSection">
          <table className="printTable printReportTable landscapeTable" ref={(node) => (this.printPart = node)}>
            <HeaderTablePrint
              header="لیست کاربران پرسینا"
              reporter={reporterName}
              timePrint={jMoment().format('jYYYY/jM/jD HH:mm')}
              headerColSpan={11}
              rightColSpan={6}
              centerColSpan={1}
              leftColSpan={4}
              centerSection={''}
              rightSection={'تاریخ ثبت از : ' + this.state.toPrintDate + ' تا ' + this.state.fromPrintDate}
              columns={columnPrint}
            />

            <tbody>
              {this.state.printInfo.map((operators, index) => (
                <tr key={'i' + index} style={index % 2 == 0 ? {backgroundColor: '#f1f1f1'} : {backgroundColor: '#fff'}}>
                  <td>{index + 1}</td>
                  <td>{operators.firstName + '  ' + operators.lastName}</td>
                  <td>{operators.legal ? 'حقوقی' : 'حقیقی'}</td>
                  <td>{operators.username}</td>
                  <td>{operators.phone == null ? '' : operators.phone.replace(/\+98/g, '0')}</td>
                  <td>{operators.phoneConfirmed ? 'تایید شده' : 'تایید نشده'}</td>
                  <td>{operators.userCode}</td>
                  <td>{jMoment(operators.registrationTime).format('jYY/jMM/jDD HH:mm')}</td>
                  <td>{operators.email == null ? '-' : operators.email}</td>
                  <td>{operators.emailConfirmed ? 'تایید شده' : 'تایید نشده'}</td>
                  <td>{operators.organization == null ? '-' : operators.organization}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <div className="wrapperIframe">
          <ul className="breadcrumb">
            <li>
              <Link to={'/search'}>به روزرسان</Link>
            </li>
            <li>کاربران</li>
            <li>کاربران پرسینا</li>
          </ul>
          <div className="tableComponent">
            <div className="tableTools">
              <div className="tableOptionWrapp">
                <HeaderTable
                  addUrl=""
                  printUrl=""
                  url={USER_REPORT.USER_REPORT_ASPUSER}
                  ChangeDropDown={this.changeDropDown.bind(this)}
                  printComponent={this.printTable}
                  execelUrl={USER_REPORT.USER_REPORT_ASPUSER + '?export=true'}
                  excelColumns={[]}
                  titleAdd=""
                  printLink=""
                />
                <button className="filterBtn">
                  <i className="fa fa-search" />
                </button>
                <button className={'filterBtn'} onClick={this.exportExcel}>
                  <i className="fas fa-file-excel" />
                </button>
                <button className="printButton" onClick={this.exportPrint}>
                  <i className="fas fa-print" />
                </button>
              </div>
            </div>
            <div className="basketFilterComponent">
              <div className="filterInputs">
                <FromToPicker
                  onChangeFromDate={this.handleChangeFromDate}
                  onChangeToDate={this.handleChangeToDate}
                  fromLabel="تاریخ ثبت از"
                  toLabel="تاریخ ثبت تا"
                  fromId="from"
                  toId="to"
                  defaulValue={true}
                />

                <div className="formComponent">
                  <label>کد مشتری</label>
                  <input className="form-control" id="userCode" type="text" />
                </div>

                <div className="formComponent">
                  <label>نوع کاربر</label>
                  <select id="legal" className="form-control">
                    <option value="">------</option>
                    <option value={0}>حقیقی</option>
                    <option value={1}>حقوقی</option>
                  </select>
                </div>

                <div className="formComponent">
                  <label>نام</label>
                  <input className="form-control" id="firstname" type="text" />
                </div>
                <div className="formComponent">
                  <label>نام خانوادگی</label>
                  <input className="form-control" id="lastname" type="text" />
                </div>
                <div className="formComponent">
                  <label>نام کاربری</label>
                  <input className="form-control" id="username" type="text" />
                </div>

                <div className="formComponent">
                  <label>تلفن</label>
                  <input className="form-control" id="phone" type="text" />
                </div>

                <div className="formComponent">
                  <label>تایید تلفن</label>
                  <select id="phoneConfirmed" className="form-control">
                    <option value="">------</option>
                    <option value={0}>تایید نشده</option>
                    <option value={1}>تایید شده</option>
                  </select>
                </div>

                <div className="formComponent">
                  <label>ایمیل</label>
                  <input className="form-control" id="email" type="text" />
                </div>

                <div className="formComponent">
                  <label>تایید ایمیل</label>
                  <select id="emailConfirmed" className="form-control">
                    <option value="">------</option>
                    <option value={0}>تایید نشده</option>
                    <option value={1}>تایید شده</option>
                  </select>
                </div>

                <div className="formComponent">
                  <label>نام سازمان</label>
                  <input className="form-control" id="organization" type="text" />
                </div>
              </div>
              <div className="filterOption">
                <button className="confirmFilter" onClick={this.filter.bind(this)}>
                  جست و جو
                </button>
              </div>
            </div>
            <div className="printSection">
              <table className="printTable" ref={(node) => (this.printPart = node)}>
                <tbody />
              </table>
            </div>
            <div className="showBaseTable print">
              <table className="baseTable">
                <tbody>
                  <tr className="firstRow">
                    <td>ردیف</td>
                    <td>نام</td>
                    <td>نوع کاربر</td>
                    <td>نام کاربری</td>
                    <td>تلفن</td>
                    <td>تایید تلفن</td>
                    <td>کد کاربر</td>
                    <td>تاریخ ثبت</td>
                    <td>ایمیل</td>
                    <td>تایید ایمیل</td>
                    <td>نام سازمان</td>
                  </tr>
                  {this.state.persina.map((operators, index) => (
                    <tr key={index}>
                      <td>{(pageNumber - 1) * dropDownVal + index + 1}</td>
                      <td>{operators.firstName + '  ' + operators.lastName}</td>
                      <td>{operators.legal ? 'حقوقی' : 'حقیقی'}</td>
                      <td>{operators.username}</td>
                      <td>{operators.phone == null ? '' : operators.phone.replace(/\+98/g, '0')}</td>
                      <td>{operators.phoneConfirmed ? 'تایید شده' : 'تایید نشده'}</td>
                      <td>{operators.userCode}</td>
                      <td>{jMoment(operators.registrationTime).format('jYY/jMM/jDD HH:mm')}</td>
                      <td>{operators.email == null ? '-' : operators.email}</td>
                      <td>{operators.emailConfirmed ? 'تایید شده' : 'تایید نشده'}</td>
                      <td>{operators.organization == null ? '-' : operators.organization}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
              <div className="paginationWrapp">
                <Page
                  defaultCurrent={1}
                  total={this.state.total}
                  onResultFetched={this.onResultFetched.bind(this)}
                  urlParams={sessionStorage.getItem('params')}
                  url={USER_REPORT.USER_REPORT_ASPUSER}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}
export default PersinaUsers
